import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import StartExecutionIcon from './StartExecutionIcon';

export default function StartExecutionButton(props) {
  const { onClick, tooltip } = props;

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={onClick}>
        <StartExecutionIcon/>
      </IconButton>
    </Tooltip>
  );
}

StartExecutionButton.propTypes = {
  onClick: PropTypes.func,
  tooltip: PropTypes.string.isRequired,
};

StartExecutionButton.defaultProps = {
  tooltip: "Start new execution",
};
